import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useFilters } from './useFilters'

import { FILTER_TYPES } from '~constants'
import { CategoryType } from '~contexts/FiltersContext'
import { priceRange } from '~utils'

export type FilterType = {
  filterType:
    | typeof FILTER_TYPES.COIN_RANGE
    | typeof FILTER_TYPES.LOCATION
    | typeof FILTER_TYPES.OFFER_STATUS
  label: string
}

export type CheckBoxType = CategoryType & {
  filterType: typeof FILTER_TYPES.CHECKBOX
}

export const useGetPickedFilters = () => {
  const {
    filtersState: {
      categoriesList,
      coinRange: { from, to },
      selectedLocation,
      selectedOfferStatus,
    },
  } = useFilters()
  const { t } = useTranslation()

  const pickedCheckBoxes: CheckBoxType[] = useMemo(() => {
    return categoriesList
      .filter(({ isChecked }) => isChecked === true)
      .map((el) => {
        return { ...el, filterType: FILTER_TYPES.CHECKBOX }
      })
  }, [categoriesList])

  const pickedLocation: FilterType[] = useMemo(() => {
    return selectedLocation.label
      ? [{ filterType: FILTER_TYPES.LOCATION, label: selectedLocation.label }]
      : []
  }, [selectedLocation.label])

  const insertedCoinRange: FilterType[] = useMemo(() => {
    return from || to
      ? [
          {
            filterType: FILTER_TYPES.COIN_RANGE,
            label: priceRange(from, to, t('common.coins')),
          },
        ]
      : []
  }, [from, t, to])

  const pickedOfferStatus: FilterType[] = useMemo(() => {
    return selectedOfferStatus.value
      ? [{ filterType: FILTER_TYPES.OFFER_STATUS, label: selectedOfferStatus.label }]
      : []
  }, [selectedOfferStatus.label, selectedOfferStatus.value])

  const pickedFilters = useMemo(() => {
    return [...insertedCoinRange, ...pickedCheckBoxes, ...pickedLocation, ...pickedOfferStatus]
  }, [insertedCoinRange, pickedCheckBoxes, pickedLocation, pickedOfferStatus])

  return { pickedFilters }
}
